import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'WithTimesTop10' */ './WithTimesTop10'),
  loading: () => null,
  // delay: 2000,
});

export default class TimesTop10Loader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    // this.setState({});
    setTimeout(() => {
      this.setState({ load: true });
    }, 2000);
  }
  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} />;
  }
}
